import React from 'react';
import { useHistory } from 'react-router';
import { DashboardRoute } from './routes';

export function RenderConditionally(props: {
	children: any;
	redirectToDashboard?: boolean;
}) {
	const history = useHistory();

	// Perform the redirect using the effect hook
	React.useEffect(() => {
		if (props.redirectToDashboard) {
			history.push(DashboardRoute);
		}
	}, [props.redirectToDashboard, history]);

	// The effect will handle the actual navigation, so return null
	return props.redirectToDashboard ? null : <>{props.children}</>;
}
